import type { TractorWithAxlesResponse } from '@contracts/tractor/TractorWithAxlesResponse';
import type { Client } from '@src/clients/domain/Client';
import { BackButton } from '@src/common/components/button/BackButton';
import { PageLayout } from '@src/common/components/Page';
import { Stack } from '@src/common/components/Stack';
import { MeasurementToggle } from '@src/common/measurements/MeasurementToggle';
import { useMeasurement } from '@src/common/measurements/useMeasurement';
import type { TractorFormInputs } from '@src/tractor/TractorFormInputs';
import { TractorPageForm } from '@src/tractor/TractorPageForm';
import { type SubmitHandler } from 'react-hook-form';
import type * as yup from 'yup';

interface Props {
  client: Client;
  onSubmit: (data: yup.InferType<typeof TractorFormInputs>) => void;
  onCancel: () => void;
  onBack: () => void;
  isLoading: boolean;
  prefillData?: TractorWithAxlesResponse;
}

export const TractorPageContent = ({
  client,
  isLoading,
  onCancel,
  onBack,
  onSubmit,
  prefillData,
}: Props) => {
  const { isMetric, setIsMetric } = useMeasurement();

  const submitForm: SubmitHandler<yup.InferType<typeof TractorFormInputs>> = (
    data,
  ) => {
    onSubmit(data);
  };

  return (
    <PageLayout title={client.name}>
      <Stack alignItems="flex-end">
        <MeasurementToggle isMetric={isMetric} setIsMetric={setIsMetric} />
      </Stack>
      <Stack direction="row">
        <BackButton onClick={onBack} />
      </Stack>
      <TractorPageForm
        prefillData={prefillData}
        onSubmit={submitForm}
        onCancel={onCancel}
        isLoading={isLoading}
      />
    </PageLayout>
  );
};
